export default __webpack_public_path__ + "static/media/OJK_Logo_2.e56fe179.png";